import styled, { css } from 'styled-components';
export const DividerElement = styled.hr(({ theme }) => css `
    width: 100%;
    border: none;
    height: 1px;
    background-color: ${theme.colors.borders.default};
  `);
//# sourceMappingURL=divider.styles.js.map